import { render, staticRenderFns } from "./NextMoveFooter.vue?vue&type=template&id=0687ac1e&scoped=true"
import script from "./NextMoveFooter.vue?vue&type=script&lang=ts"
export * from "./NextMoveFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0687ac1e",
  null
  
)

export default component.exports